import { useQuoteBuilderActions } from '@paradigm/features/src/unified-rfqs/ui/grfq/quote-builder/form-context';
import { useQuoteBuilderView } from '@paradigm/features/src/unified-rfqs/ui/grfq/quote-builder/view';
import { useGrfqRfq } from '@paradigm/features/src/unified-rfqs/ui/rfq-context';

import BaseAccountSelect from '#/components/account-selection/AccountSelect';
import useAccountsWithDefault from '@paradigm/features/src/preferences/default-accounts/useAccountsWithDefault';
import { findBaseProductCode } from '@paradigm/features/src/products/domain';

function AccountSelect() {
  const { account } = useQuoteBuilderView();
  const { changeAccount } = useQuoteBuilderActions();
  const { venue, product_codes } = useGrfqRfq();
  const productCode = findBaseProductCode(product_codes);
  const cachedAccounts = useAccountsWithDefault(venue, productCode);

  return (
    <BaseAccountSelect
      value={account}
      venue={venue}
      productCode={productCode}
      onChange={(value) => changeAccount(value)}
      cachedAccounts={cachedAccounts}
    />
  );
}

export default AccountSelect;
